/*eslint-disable*/
import api from '../'

class parsingSentencePartsSpeech {
    // POST: couples
    static getItemsByRequest (params) {
        return api.axios.get('/parsingSentencePartsSpeech/items', { params }).then(response => response.data.items);
    }
}

export default parsingSentencePartsSpeech;
